import React, { useState } from 'react';
import classnames from 'classnames';
import { shape, string } from 'prop-types';
import { Icon, Section } from '@fiverr-private/fit';
import { StatusToast } from '@fiverr-private/orca';
import { s_exclamation_circle } from '@fiverr-private/fit/icons';
import { validateEmail, trackEvent } from './utils';
import {
    UI_MODES,
    GENERIC_SERVER_ERROR_MESSAGE,
    EVENT_TYPES
} from './constants';
import { resend } from './api';
import SubmitButton from './components/SubmitButton';
import MessageBody from './components/MessageBody';
import LinkProvider from './components/LinkProvider';

import './style.scss';

const UserActivation = ({ user }) => {
    const [mode, setMode] = useState(UI_MODES.DEFAULT);
    const [errorMessage, setErrorMessage] = useState('');
    const [email, setEmail] = useState(user.email);

    const onEditClick = () => {
        trackEvent(EVENT_TYPES.EDIT_CLICKED);
        setMode(UI_MODES.EDIT);
    };

    const onCancelClick = () => {
        setMode(UI_MODES.DEFAULT);
        setEmail(user.email);
        setErrorMessage('');
    };

    const onEmailChange = ({ target: { value } }) => {
        setEmail(value);
    };

    const onSubmit = async() => {
        const [firstError] = validateEmail(email);
        if (firstError) {
            return setErrorMessage(firstError);
        }

        setErrorMessage('');

        try {
            const data = {
                username: user.username,
                email
            };

            setMode(UI_MODES.LOADING);

            await resend(data);

            StatusToast.raise({
                message: i18n.t('layout.global_messages.user_activation.submitted')
            });
            setMode(UI_MODES.SUBMITTED);

            const event = email !== user.email ? EVENT_TYPES.UPDATE_EMAIL_SUBMIT : EVENT_TYPES.SUBMIT;
            trackEvent(event);
        } catch (error) {
            StatusToast.raise({
                message: error.message || i18n.t(GENERIC_SERVER_ERROR_MESSAGE),
                theme: StatusToast.THEMES.ERROR
            });

            setMode(UI_MODES.DEFAULT);
        }
    };

    const classNames = classnames(
        'user-activation',
        'tbody-6',
        {
            'edit-mode': mode === UI_MODES.EDIT
        }
    );

    const disabled = mode === UI_MODES.SUBMITTED;
    const isLoading = mode === UI_MODES.LOADING;

    return (
        <div className={classNames}>
            <Section className="container">
                <Icon className="icon">{s_exclamation_circle}</Icon>
                <div className="content-container">
                    <MessageBody username={user.username}
                        mode={mode}
                        email={email}
                        errorMessage={errorMessage}
                        onEmailChange={onEmailChange}
                        onEditClick={onEditClick}
                        onCancelClick={onCancelClick}/>
                    {mode === UI_MODES.SUBMITTED ?
                        <LinkProvider email={email}/> :
                        <SubmitButton onSubmit={onSubmit}
                            isLoading={isLoading}
                            mode={mode}
                            disabled={disabled}
                            email={email}/>
                    }
                </div>
            </Section>
        </div>
    );
};

UserActivation.propTypes = {
    user: shape({
        email: string.isRequired,
        username: string.isRequired
    })
};

export * from './show';

export default UserActivation;
